// import React, { useRef } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";

// const pages = [
//   {
//     title: "TERMS OF USE",
//     content:
//       "This work is out of copyright and in the public domain. However, the formatting and editorial work applied remains the property of Ebooks Corporation.This work is out of copyright and in the public domain. However, the formatting and editorial work applied remains the property of Ebooks Corporation.This work is out of copyright",
//   },
//   {
//     title: "PERMITTED USE",
//     content:
//       "You may store and retrieve unlimited copies of this work for personal and non-commercial use. Any commercial use requires prior consent.You may store and retrieve unlimited copies of this work for personal and non-commercial use. Any commercial use requires prior consent.You may store and retrieve unlimited copies of this work",
//   },
//   {
//     title: "PROHIBITED USE",
//     content:
//       "You may not copy, sell, distribute, or adapt this work for commercial purposes, including free distribution for promotion. You may not copy, sell, distribute, or adapt this work for commercial purposes, including free distribution for promotion.You may not copy, sell, distribute, or adapt this work for commercial purposes, including",
//   },
// ];

// const SimpleTextSlider = () => {
//   const swiperRef = useRef(null);

//   const handleNavigation = (event) => {
//     const { clientX } = event;
//     const screenWidth = window.innerWidth / 2;

//     if (swiperRef.current) {
//       if (clientX > screenWidth) {
//         swiperRef.current.slideNext();
//       } else {
//         swiperRef.current.slidePrev();
//       }
//     }
//   };

//   return (
//     <div className="flex  ">
//       <Swiper
//         onSwiper={(swiper) => (swiperRef.current = swiper)}
//         className=" text-black"
//       >
//         {pages.map((page, index) => (
//           <SwiperSlide key={index} onClick={handleNavigation} className="p-4">
//             <h2
//               className="text-2xl font-extrabold text-gray-800 tracking-wide uppercase"
//               style={{
//                 textAlign: "center",
//                 margin: "0 auto 10px auto",
//                 textTransform: "uppercase",
//                 letterSpacing: "1px",
//                 position: "relative",
//               }}
//             >
//               {page.title}
//               <span
//                 style={{
//                   display: "block",
//                   width: "50px",
//                   height: "3px",
//                   backgroundColor: "#4A90E2",
//                   margin: "8px auto 0 auto",
//                   borderRadius: "2px",
//                 }}
//               />
//             </h2>

//             <p className="text-sm leading-relaxed">{page.content}</p>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// };

// export default SimpleTextSlider;

// import React, { useRef, useEffect, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { useParams } from "react-router-dom";
// import "swiper/css";
// import axios from "axios";
// import { CircularProgress, Box, Typography } from "@mui/material";
// import endpoints from "../../../endpoint";

// const SimpleTextSlider = () => {
//   const { id } = useParams();
//   const swiperRef = useRef(null);
//   const [pages, setPages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchEbookPages = async () => {
//       try {
//         const response = await axios.get(
//           `${endpoints.serverBaseUrl}api/ebook/${id}`
//         );
//         setPages(response.data.pages);
//       } catch (error) {
//         console.error("Failed to fetch ebook pages:", error);
//         setError("Failed to load ebook pages");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEbookPages();
//   }, [id]);

//   const handleNavigation = (event) => {
//     const { clientX } = event;
//     const screenWidth = window.innerWidth / 2;

//     if (swiperRef.current) {
//       if (clientX > screenWidth) {
//         swiperRef.current.slideNext();
//       } else {
//         swiperRef.current.slidePrev();
//       }
//     }
//   };

//   if (loading) {
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Typography sx={{ textAlign: "center", mt: 4, color: "red" }}>
//         {error}
//       </Typography>
//     );
//   }

//   return (
//     <div className="flex">
//       <Swiper
//         onSwiper={(swiper) => (swiperRef.current = swiper)}
//         className="text-black"
//       >
//         {pages.map((page, index) => (
//           <SwiperSlide key={index} onClick={handleNavigation} className="p-4">
//             <h2
//               className="text-2xl font-extrabold text-gray-800 tracking-wide uppercase"
//               style={{
//                 textAlign: "center",
//                 margin: "0 auto 10px auto",
//                 textTransform: "uppercase",
//                 letterSpacing: "1px",
//                 position: "relative",
//               }}
//             >
//               {page.title}
//               <span
//                 style={{
//                   display: "block",
//                   width: "50px",
//                   height: "3px",
//                   backgroundColor: "#4A90E2",
//                   margin: "8px auto 0 auto",
//                   borderRadius: "2px",
//                 }}
//               />
//             </h2>

//             <p className="text-sm leading-relaxed">{page.content}</p>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// };

// export default SimpleTextSlider;

import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useParams } from "react-router-dom";
import "swiper/css";
import axios from "axios";
import { CircularProgress, Box, Typography } from "@mui/material";
import endpoints from "../../../endpoint";

const SimpleTextSlider = () => {
  const { id } = useParams();
  const swiperRef = useRef(null);
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEbookPages = async () => {
      try {
        const response = await axios.get(
          `${endpoints.serverBaseUrl}api/ebook/${id}`
        );
        setPages(response.data.pages);
      } catch (error) {
        console.error("Failed to fetch ebook pages:", error);
        setError("Failed to load ebook pages");
      } finally {
        setLoading(false);
      }
    };

    fetchEbookPages();
  }, [id]);

  const handleNavigation = (event) => {
    const { clientX } = event;
    const screenWidth = window.innerWidth / 2;

    if (swiperRef.current) {
      if (clientX < screenWidth) {
        swiperRef.current.slidePrev(); // Left side → go to previous
      } else {
        swiperRef.current.slideNext(); // Right side → go to next
      }
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography sx={{ textAlign: "center", mt: 4, color: "red" }}>
        {error}
      </Typography>
    );
  }

  return (
    <div className="flex w-full h-screen" onClick={handleNavigation}>
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        className="w-full h-full text-black"
      >
        {pages.map((page, index) => (
          <SwiperSlide key={index} className="p-4 flex flex-col justify-center">
            <h2
              className="text-2xl font-extrabold text-gray-800 tracking-wide uppercase"
              style={{
                textAlign: "center",
                margin: "0 auto 10px auto",
                letterSpacing: "1px",
              }}
            >
              {page.title}
              <span
                style={{
                  display: "block",
                  width: "50px",
                  height: "3px",
                  backgroundColor: "#4A90E2",
                  margin: "8px auto 0 auto",
                  borderRadius: "2px",
                }}
              />
            </h2>

            <p className="text-sm leading-relaxed text-justify mt-4">
              {page.content}
            </p>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SimpleTextSlider;
